import {getCountries, CountryCode} from 'libphonenumber-js';

const COUNTRIES = getCountries();

// Similar to manage/frontend/src/intl/isTranslated.tsx
export const countryForLocale = (locale: string): CountryCode | null => {
  if (locale === 'es-419') {
    return 'MX';
  } else if (['zh-Hans', 'zh-Hant'].includes(locale)) {
    return 'CN';
  } else {
    const localeComponents = locale.split('-');
    const country = localeComponents[localeComponents.length - 1];
    if (country && country in COUNTRIES) {
      return country as CountryCode;
    }
  }

  return null;
};
